import React from 'react';
import { Box, Divider } from '@mui/material';
import { Typography } from '../Typography';

export interface DetailPageSidebarSectionProps {
  /**
   * The title of the section
   */
  title?: string;
  /**
   * The content of the section(gap of 8px is applied between each item here)
   */
  children: React.ReactNode;
  /**
   * Whether the section is the first section(no top padding is applied)
   */
  isFirstSection?: boolean;
  /**
   * Whether the section has a gap between items only(no divider or other styling)
   */
  isGapOnlyVariant?: boolean;
  /**
   * The test id of the section
   */
  sectionDataTestId?: string;
}

export const DetailPageSidebarSection = ({
  title,
  children,
  isFirstSection = false,
  sectionDataTestId,
  isGapOnlyVariant = false,
}: DetailPageSidebarSectionProps) => {
  return (
    <>
      <Box
        paddingTop={isFirstSection || isGapOnlyVariant ? '0' : '20px'}
        paddingBottom={isGapOnlyVariant ? '0' : '32px'}
        display="flex"
        flexDirection="column"
        gap={'8px'}
        component="section"
        data-testid={sectionDataTestId}
      >
        {title && (
          <Typography
            component="h3"
            fontWeight={'600'}
            fontSize={'14px'}
            color={'#475467'}
            sx={{ padding: '0 4px 12px 4px' }}
          >
            {title}
          </Typography>
        )}
        {children}
      </Box>
      {!isGapOnlyVariant && <Divider />}
    </>
  );
};
